import React from "react";
import "./Blogs.css";
import MainLayout from "../../components/MainLayout/MainLayout";
import Images from "../../constants/Images";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBook,
  faCode,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Blogs = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  // Intersection observer hooks for scroll animations
  const [blogsHeaderRef, blogsHeaderInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [blogsContentRef, blogsContentInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <MainLayout>
      <motion.div
        className="blogs-wrapper"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {/* Blogs Header */}
        <section className="blogs-header-section" ref={blogsHeaderRef}>
          <div className="blogs-container">
            <motion.div
              className="blogs-header"
              initial={{ opacity: 0, y: 30 }}
              animate={
                blogsHeaderInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }
              }
              transition={{ duration: 0.8 }}
            >
              <h1 className="blogs-title">My Blog Collection</h1>
              <div className="blogs-title-underline"></div>
              <motion.p
                className="blogs-intro"
                initial={{ opacity: 0 }}
                animate={blogsHeaderInView ? { opacity: 1 } : { opacity: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                Insights, experiences, and lessons from my professional journey
              </motion.p>
            </motion.div>
          </div>
        </section>

        {/* Blogs Content */}
        <section className="blogs-content-section" ref={blogsContentRef}>
          <div className="blogs-container">
            <motion.div
              className="blogs-grid"
              variants={containerVariants}
              initial="hidden"
              animate={blogsContentInView ? "visible" : "hidden"}
            >
              {/* Peregrine's 12 Week Training Blog Card */}
              <motion.div className="blog-card" variants={itemVariants}>
                <div className="blog-card-image">
                  <img src={Images.Peregrine} alt="Peregrine Training" />
                  <motion.div
                    className="blog-card-icon"
                    whileHover={{ scale: 1.2, rotate: 10 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FontAwesomeIcon icon={faBook} />
                  </motion.div>
                </div>
                <div className="blog-card-content">
                  <h2>Embark on a 12-Week Journey at Peregrine</h2>
                  <p>
                    Dive into my experiences as I navigate through the Peregrine
                    Software Development Graduate Programme. Over the course of
                    12 transformative weeks, I've tackled real-world projects,
                    embraced new challenges, and witnessed my growth as a
                    software developer.
                  </p>
                  <motion.div
                    className="blog-card-footer"
                    whileHover={{ y: -5 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Link to="/Blogs/Peregrine" className="blog-card-button">
                      Explore My 12-Week Journey{" "}
                      <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                    <span className="blog-card-date">
                      Latest Update: Apr 15, 2025
                    </span>
                  </motion.div>
                </div>
              </motion.div>

              {/* The Config Team Journey Blog Card */}
              <motion.div className="blog-card" variants={itemVariants}>
                <div className="blog-card-image">
                  <img src={Images.TCT} alt="The Config Team" />
                  <motion.div
                    className="blog-card-icon"
                    whileHover={{ scale: 1.2, rotate: 10 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FontAwesomeIcon icon={faCode} />
                  </motion.div>
                </div>
                <div className="blog-card-content">
                  <h2>
                    The Config Team Journey: Mastering SAP & Logistics
                    Excellence
                  </h2>
                  <p>
                    Embark with me on a dynamic journey as a
                    Technical Consultant at The Config Team (TCT). Follow my
                    progress as I enhance my technical skills and contribute to
                    innovative solutions in the SAP logistics space.
                  </p>
                  <div className="blog-card-badge">
                    <span>Coming Soon!</span>
                  </div>
                  <motion.div
                    className="blog-card-footer"
                    whileHover={{ y: -5 }}
                    transition={{ duration: 0.3 }}
                  >
                    <a
                      href="https://theconfigteam.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blog-card-button secondary"
                    >
                      Visit The Config Team Website{" "}
                      <FontAwesomeIcon icon={faArrowRight} />
                    </a>
                  </motion.div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>
      </motion.div>
    </MainLayout>
  );
};

export default Blogs;
